import { BordButton } from 'bord-design-system';
import './CreateNewToolButton.scss';

interface ICreateNewToolButton {
  onClick: () => void;
}

/**
 * Botón reutilizable para iniciar la creación de una herramienta nueva en el buscador de herramientas.
 */
const CreateNewToolButton = ({ onClick }: ICreateNewToolButton) => (
  <BordButton
    label="Crear herramienta nueva (SKU)"
    bordButtonStyle="outlined"
    customWidth="w-280"
    customClassName="createNewToolButton"
    onClick={onClick}
  />
);

export default CreateNewToolButton;
